import React from "react";
import { motion } from "framer-motion";

const easing = [0.16, 1, 0.3, 1];

/** Fade + slide up on scroll into view. */
export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true, ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-60px" }}
    transition={{ duration: 0.8, ease: easing, delay }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

/** Masked line-by-line reveal for large display text (on load). */
export const LineReveal = ({ lines = [], className = "", delay = 0, stagger = 0.12 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="reveal-mask">
        <motion.span
          className="inline-block"
          initial={{ y: "125%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, ease: easing, delay: delay + i * stagger }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export default Reveal;
